var map = {
	"./107x107 (1).png": 2284,
	"./1st.png": 4577,
	"./All Components.png": 2363,
	"./Announcement1.png": 6050,
	"./DCP2-gif-2.gif": 821,
	"./DCP2-gif.gif": 8955,
	"./Thank-You-Card.png": 4330,
	"./YLAC Digital.3021a8625f44a24fbbeb.png": 378,
	"./YLAC Digital.png": 1174,
	"./YLAC logo-01.png": 4810,
	"./annouce.png": 9789,
	"./announcmen.png": 4774,
	"./announcment.png": 7749,
	"./baslineBgLeft.png": 4053,
	"./baslineBgLeftBig.png": 9838,
	"./baslineBgRight.png": 8113,
	"./baslineBgRightBig.png": 7060,
	"./bgimg.png": 5432,
	"./bgimg1.png": 3408,
	"./book.png": 4004,
	"./bowlcheck-old.png": 5025,
	"./bowlcheck.png": 8220,
	"./bulb.png": 196,
	"./certificate.png": 4464,
	"./coins/1.png": 9989,
	"./coins/10.png": 3840,
	"./coins/11.png": 9146,
	"./coins/12.png": 8674,
	"./coins/13.png": 7455,
	"./coins/14.png": 1593,
	"./coins/15.png": 7774,
	"./coins/2.png": 9184,
	"./coins/3.png": 6089,
	"./coins/4.png": 3834,
	"./coins/5.png": 9616,
	"./coins/6.png": 518,
	"./coins/7.png": 3650,
	"./coins/8.png": 3413,
	"./coins/9.png": 4830,
	"./commas1.png": 1215,
	"./commas2.png": 6101,
	"./course.png": 9054,
	"./ddagency.png": 9634,
	"./digi1.png": 5563,
	"./digi2.png": 9747,
	"./digitalambasdddd-old.png": 2459,
	"./digitalambasdddd.png": 482,
	"./digitalsafty.png": 8126,
	"./digitalwell.png": 7978,
	"./dragdrop/1.png": 3410,
	"./dragdrop/2.png": 9266,
	"./dragdrop/3.png": 649,
	"./dragdrop/gameball.png": 1790,
	"./dragdrop/match/DCP Design and Layouts (150 × 150px) (3).png": 5249,
	"./dragdrop/match/dcp-gif0.gif": 9503,
	"./dragdrop/match/dcp-gif1.gif": 9980,
	"./dragdrop/match/dcp-gif2.gif": 8585,
	"./dragdrop/match/dcp-gif3.gif": 7705,
	"./dragdrop/match/dcp-gif4.gif": 5714,
	"./dragdrop/match/dcp-gif5.gif": 5667,
	"./dragdrop/match/qus.png": 4882,
	"./dragdrop/match/wt.png": 1298,
	"./dragdrop/rightbucket-1.png": 3608,
	"./dragdrop/rightbucket.png": 2349,
	"./dragdrop/wrongbucket-1.png": 5631,
	"./dragdrop/wrongbucket.png": 3858,
	"./eccosystem.png": 1572,
	"./emeil-old-2.png": 1526,
	"./emeil-old-22.png": 2199,
	"./emeil-old-3.png": 593,
	"./emeil-old.png": 3837,
	"./emeil.png": 5472,
	"./game-icons_digital-trace.png": 4166,
	"./gift.png": 5330,
	"./homedesign.png": 9868,
	"./icons/Homeic.png": 2929,
	"./icons/Left icon.png": 2235,
	"./icons/Vector.png": 147,
	"./icons/aboutss.png": 7186,
	"./icons/annoucee.png": 3705,
	"./icons/certified.png": 4578,
	"./icons/coursees.png": 6114,
	"./icons/dashicons_testimonial.png": 8743,
	"./icons/digi.png": 6761,
	"./icons/feedback.png": 2771,
	"./icons/gg_profile.png": 3932,
	"./icons/home.png": 5474,
	"./icons/iconamoon_certificate-badge-light.png": 9864,
	"./icons/logoutss.png": 8392,
	"./icons/material-symbols_lab-profile-outline-rounded.png": 2900,
	"./icons/mdi_announcement-outline.png": 7113,
	"./icons/mdi_resource-description-framework.png": 9818,
	"./icons/menu_left.png": 5763,
	"./icons/openmoji_books.png": 6174,
	"./icons/progeresss.png": 2976,
	"./icons/resoudes.png": 9307,
	"./icons/users.png": 407,
	"./ikig.png": 6252,
	"./image/hindi/ylac.png": 8120,
	"./image/hindi/ylac1.png": 6850,
	"./image/hindi/ylac2.png": 3922,
	"./image/hindi/ylac3.png": 547,
	"./image/hindi/ylac4.png": 7337,
	"./image/old-2/ylac.jpg": 5189,
	"./image/old-2/ylac1.jpg": 187,
	"./image/old-2/ylac2.jpg": 9939,
	"./image/old-2/ylac3.jpg": 3051,
	"./image/quiz14/english/ylac.png": 2651,
	"./image/quiz14/english/ylac1.png": 8748,
	"./image/quiz14/english/ylac2.png": 2742,
	"./image/quiz14/english/ylac3.png": 3423,
	"./image/quiz14/english/ylac4.png": 2359,
	"./image/quiz14/hindi/ylac.png": 5374,
	"./image/quiz14/hindi/ylac1.png": 1256,
	"./image/quiz14/hindi/ylac2.png": 9092,
	"./image/quiz14/hindi/ylac3.png": 371,
	"./image/quiz14/hindi/ylac4.png": 1373,
	"./image/quiz7/YLAC Degital Champions (1)/Group 1000002615.png": 450,
	"./image/quiz7/english/ylac.png": 5127,
	"./image/quiz7/english/ylac1.png": 5195,
	"./image/quiz7/english/ylac2.png": 3673,
	"./image/quiz7/english/ylac3.png": 3540,
	"./image/quiz7/english/ylac4.png": 7430,
	"./image/quiz7/english/ylac5.png": 9610,
	"./image/quiz7/hindi/ylac.png": 3161,
	"./image/quiz7/hindi/ylac1.png": 5379,
	"./image/quiz7/hindi/ylac2.png": 6318,
	"./image/quiz7/hindi/ylac2gd.png": 4765,
	"./image/quiz7/hindi/ylac3.png": 7890,
	"./image/quiz7/hindi/ylac4.png": 5303,
	"./image/quiz7/hindi/ylac5.png": 8821,
	"./image/quiz7/pdf/eng.pdf": 7289,
	"./image/quiz7/pdf/hindi.pdf": 8402,
	"./image/quiz7/pdf/ylac.png": 7352,
	"./image/ssa/ylac.png": 854,
	"./image/ssa/ylac1.png": 767,
	"./image/ssa/ylac2.png": 848,
	"./image/ssa/ylac3.png": 5272,
	"./image/ylac.png": 6409,
	"./image/ylac1.png": 4824,
	"./image/ylac2.png": 321,
	"./image/ylac3.png": 3098,
	"./image/ylac4.png": 9648,
	"./imogi1.png": 4524,
	"./inf.png": 4139,
	"./instructions-old.png": 4488,
	"./instructions.png": 9123,
	"./lock.png": 307,
	"./login-img.png": 8537,
	"./logo-green_green.png": 1396,
	"./logo-old.png": 213,
	"./logo-old2.png": 5104,
	"./logoCoin.png": 7864,
	"./logobg-old.png": 9722,
	"./logobg.png": 7461,
	"./logout.png": 6919,
	"./myprogress.png": 3603,
	"./myprogress2.png": 7055,
	"./offer.png": 7753,
	"./progress.png": 1430,
	"./progressic.png": 7906,
	"./que.png": 9107,
	"./ques.png": 3987,
	"./ques2.png": 4456,
	"./quize.png": 8741,
	"./qut1.png": 1557,
	"./qut2.png": 6497,
	"./req.png": 1979,
	"./resourse.png": 1714,
	"./robo1.png": 4558,
	"./robo2.png": 1209,
	"./robo3.png": 5132,
	"./schoolhome.png": 5759,
	"./section2/thankyou1.png": 4861,
	"./section2/thankyou2.png": 1591,
	"./section3/thankyou1.png": 3756,
	"./section3/thankyou2.png": 1562,
	"./section4/thankyou1.png": 9044,
	"./section4/thankyou2.png": 7361,
	"./seqq.png": 3489,
	"./seqq2.png": 2285,
	"./sidebar.png": 2697,
	"./social/ylac.png": 7065,
	"./star.png": 6960,
	"./star1.png": 3089,
	"./student.png": 7712,
	"./thankyou.png": 4370,
	"./thankyou1.png": 406,
	"./thankyou2.png": 8628,
	"./translate-hindi.png": 9260,
	"./twemoji_cloud-with-rain.png": 7630,
	"./unlock.png": 9885,
	"./video.png": 6178,
	"./well.png": 3205,
	"./yellow.png": 7635,
	"./ylac.png": 1330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;